import styled from "styled-components";
import { colors } from "../../../utils/styled/_variables.styled";
import { InputProps } from "./TextField.types";

export const ContainerStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FieldWrapper = styled.div`
  .input__wrapper {
    position: relative;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  color: ${colors.gray1};
`;

export const Input = styled.input<InputProps>`
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid
  ${(props) => (props.$borderColor ? colors.red : colors.gray3)};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${(props) => (props.$borderColor ? colors.red : colors.gray1)};
  width: 100%;

  &::placeholder {
    color: ${colors.gray4};
  }

  &:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  &:disabled{
    background-color: ${colors.gray3};
  }
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  color: ${colors.red};
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 28px;
  font-weight: 400;
  color: ${colors.gray2};
  margin-top: 4px;
`;

export const ErrorIcon = styled.span`
  position: absolute;
  height: 16px;
  width: 16px;
  right: 16px;
  top: calc(50% - 8px);
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.26004 5.80004L8.00004 7.06004L6.74004 5.80004C6.61549 5.67521 6.44639 5.60505 6.27004 5.60505C6.0937 5.60505 5.92459 5.67521 5.80004 5.80004C5.54004 6.06004 5.54004 6.48004 5.80004 6.74004L7.06004 8.00004L5.80004 9.26004C5.54004 9.52004 5.54004 9.94004 5.80004 10.2C6.06004 10.46 6.48004 10.46 6.74004 10.2L8.00004 8.94004L9.26004 10.2C9.52004 10.46 9.94004 10.46 10.2 10.2C10.46 9.94004 10.46 9.52004 10.2 9.26004L8.94004 8.00004L10.2 6.74004C10.46 6.48004 10.46 6.06004 10.2 5.80004C9.94004 5.54671 9.51337 5.54671 9.26004 5.80004ZM8.00004 1.33337C4.31337 1.33337 1.33337 4.31337 1.33337 8.00004C1.33337 11.6867 4.31337 14.6667 8.00004 14.6667C11.6867 14.6667 14.6667 11.6867 14.6667 8.00004C14.6667 4.31337 11.6867 1.33337 8.00004 1.33337ZM8.00004 13.3334C5.06004 13.3334 2.66671 10.94 2.66671 8.00004C2.66671 5.06004 5.06004 2.66671 8.00004 2.66671C10.94 2.66671 13.3334 5.06004 13.3334 8.00004C13.3334 10.94 10.94 13.3334 8.00004 13.3334Z" fill="%23E04C36"/></svg>');
  background-repeat: no-repeat;
  background-size: 16px;

`;
